<template>
  <div v-if="!loading" class="pc-mode">
    <header id="header">
      <div class="container">
        <div class="title">
          <a href="https://www.westjr.co.jp/" target="_blank"><img id="logo" src="../../assets/images/jr_logo.svg" width="71" alt="JR西日本旅客鉄道株式会社"></a>
          <router-link id="delay" :to="{ name: 'SiteTop' }">遅延証明書</router-link>
        </div>
      </div>
    </header>
    <div class="container">
      <article>
        <div id="termsOfService" v-if="termsOfService" v-html="termsOfService" @click="onTermsLinkClick"></div>
      </article>
    </div>
    <site-footer/>
  </div>
</template>

<script>
import SiteHeader from '@/components/pc/SiteHeader'
import SiteFooter from '@/components/pc/SiteFooter'
import { mapState } from 'vuex'
export default {
  name: 'Outline',
  components: {
    SiteHeader,
    SiteFooter
  },
  created () {
    this.$store.dispatch('areaLine/all')
    this.$store.dispatch('timeZone/all')
    this.$store.dispatch('externalData/termsService')
    this.$store.commit('loading/setStatus', false)
  },
  methods: {
    onTermsLinkClick (e) {
      const anchor = e.target.closest('a[href*="delay.trafficinfo.westjr.co.jp"]')
      if (!anchor) return
      e.preventDefault()
      this.$router.push({ name: 'SiteTop' })
    }
  },
  computed: {
    ...mapState('areaLine', {
      areas: state => state.areas
    }),
    ...mapState('externalData', {
      termsOfService: state => state.termsOfService
    }),
    ...mapState('timeZone', {
      timeZones: state => state.timeZones
    }),
    ...mapState('loading', {
      loading: state => state.status
    })
  }
}
</script>
<style lang="scss" scoped>
@import '../../css/variables';
a {
  &#delay {
    margin-left: 23px;
    font-weight: 600;
  }
}
#logo {
  margin: 10px 0px;
  background-color: #FFFFFF;
}
footer {
  min-width: 970px;
}
header {
  min-width: 970px;
  border-bottom: solid 2px #f5f5f5;
  margin-bottom: 15px;
  height: 90px;
  .title {
    font-size: 23px;
    line-height: 90px;
    color: $primary;
  }
}
#delay {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/Outline.vue